import React, {useEffect, useRef, useState, useMemo, useCallback} from 'react';
import Main from "../../modules/main/main";
import usePermissions from "../../services/auth/usePermissions";
import {useNavigate, useParams} from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import {apiUsers} from "../../services/api/users";
import {capitalizeFirst, formatLocalDate} from "../../services/common";
import TimelineTab from './tabs/timeline-tab';
import SettingsTab from './tabs/settings-tab';
import Button from "@mui/material/Button";


function User(props) {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { id } = useParams();
    const [userCan] = usePermissions();
    const [reload, setReload] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [allRoles, setAllRoles] = useState([]);
    const [title, setTitle] = useState('');
    const [userRole, setUserRole] = useState('');
    const [activeTab, setActiveTab] = useState('TIMELINE');

    const breadcrumbs = [
        {"link": "/users", "name": "Users", "active": false},
        {"name": rowData['name'] !== undefined ? rowData['name'] : '', "active": true}
    ];
    const {register, formState, handleSubmit, reset, watch, control,
        trigger, getValues, setValue, setError } = useForm({defaultValues: rowData});

    const { errors, isValid, isDirty } = formState;

    let fetchUser = React.useCallback(async ()=>{
        apiUsers.getSingle(id).then(res=>{
            setRowData(res.user);
            setAllRoles(res.roles);
            setTitle("Profile")
            setLoading(false)
            setUserRole(capitalizeFirst(res.user['roles'][0].name))
        })
    })

    // const fetchUser = async () => {
    //
    // }

    const toggle = (tab: string) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    useEffect(() => {
        // if(reload) {
        setLoading(true);
        fetchUser();
        // }
    }, [setReload])

    useEffect(() => {
        if(!userCan('view.users')){
            navigate('/');
        }
        fetchUser()
    }, [])

    useEffect(() => {
        if(Object.keys(rowData).length > 0){
            setUserRole(capitalizeFirst(rowData['roles'][0].name))
        }
    }, [rowData])



    return (
        <Main title={title} breadcrumbs={breadcrumbs} loading={loading}>
            <div className="row">
                <div className="col-md-3">
                    <div className="card card-primary card-outline">
                        <div className="card-body box-profile">
                            <h3 className="profile-username text-center">{rowData['name']}</h3>
                            <div className="text-muted text-center">Type (Role): {userRole}</div>
                            <ul className="list-group list-group-unbordered mb-3">
                                <li className="list-group-item">
                                    <b>SFA Applications</b> <a className="float-right">{rowData['sfas']?.length }</a>
                                </li>
                                <li className="list-group-item">
                                    <b>EMPOWER Applications</b> <a className="float-right">{rowData['empowers']?.length}</a>
                                </li>
                                <li className="list-group-item">
                                    <b>Joined</b> <a className="float-right">{formatLocalDate(rowData['created_at'])}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-md-9">
                    <div className="card">
                        <div className="card-header p-2">
                            <ul className="nav nav-pills">
                                <li className="nav-item mr-1">
                                    <Button
                                        type="button"
                                        disabled={!isValid}
                                        className={`nav-link ${
                                            activeTab === 'TIMELINE' ? 'active' : ''
                                        }`}
                                        onClick={() => toggle('TIMELINE')}
                                    >
                                        Timeline
                                    </Button>
                                </li>
                                <li className="nav-item mr-1">
                                    <Button
                                        type="button"
                                        disabled={!isValid}
                                        className={`nav-link ${
                                            activeTab === 'SETTINGS' ? 'active' : ''
                                        }`}
                                        onClick={() => toggle('SETTINGS')}
                                    >
                                        Settings
                                    </Button>
                                </li>
                            </ul>
                        </div>
                        <div className="card-body">
                            <div className="tab-content">
                                <TimelineTab isActive={activeTab === 'TIMELINE'} audits={rowData['audit']} user_name={rowData['name']} />
                                {userCan('edit.users') && <SettingsTab isActive={activeTab === 'SETTINGS'} user={rowData} allRoles={allRoles} setReload={e => {
                                    fetchUser();
                                }} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Main>
    );
}

export default User;